import React, { useState, useEffect } from 'react'
import { Panel } from 'rsuite'
import BudgetWidgets from './BudgetWidgets'
import ActivityBudgetWidgets from './ActivityBudgetWidgets'
import ActivityCostWidget from './ActivityCostWidget'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import CustomNote from '../../CustomNote'

export default function ManagementFeeWidget({ shaded = true, projectVersionId, ...props }) {
  const [boolExpanded, setBoolExpanded] = useState(true)
  const [activityBudgetData, setActivityBudgetData] = useState()
  const [activityOption, setActivityOption] = useState()

  const {
    showCommandButton,
    schema,
    isEditAll,
    getSummary,
    getActivity,
    handleOnChangeIsEdit,
    setIsEditWidget,
    isEditWidget,
    activityValue,
  } = props

  useEffect(() => {
    // setBoolExpanded(true)
    // if (schema[0]?.activityBudget[0]) {
    //   setActivityBudgetData(schema[0]?.activityBudget[0])
    //   // console.log('schema[0]?.activityBudget[0] ', schema[0]?.activityBudget[0])
    // }

    let acArr = []
    if (activityValue?.length > 0) {
      activityValue.map((item) => {
        acArr.push({
          label: item.activity,
          value: item.id,
        })
      })

      setActivityOption(acArr)
    } else {
      setActivityOption([])
    }
  }, [schema])

  return (
    <>
      {schema.map((item, index) => {
        if (item.form.headerOnly) {
          return (
            <Panel
              key={`managementFeeWidget_${index}`}
              shaded={shaded}
              header={item.form.header}
              collapsible
              defaultExpanded
              bordered
              style={{ marginBottom: 20 }}
            >
              {item.form.description && <CustomAlertMessageInfo contents={item.form.description} />}

              {item.subForms.map((subSchema, subIndex) => {
                if (subSchema?.name === 'activityBudget') {
                  return (
                    <ActivityCostWidget
                      key={subSchema?.name}
                      bordered
                      showCommandButton={!item.form.disabled}
                      activityId={subSchema.categoryId}
                      getSummary={getSummary}
                      getActivity={getActivity}
                      // isEditAll={isEditDetail}
                      // activityId={editId}
                      // expanded={panelExpanded}
                      // isEdit={isEditWidget[`activity_${subIndex}`]}
                      isEdit={false}
                      schema={subSchema}
                      activityOption={activityOption}
                      projectVersionId={projectVersionId}
                    />
                  )
                } else {
                  return (
                    <BudgetWidgets
                      key={`subForms_${subIndex}`}
                      formKey={`subForms_${subIndex}`}
                      bordered
                      showCommandButton={!item.form.disabled}
                      // showCommandButton={showCommandButton}
                      // isEditAll={isEditAll}
                      schema={subSchema}
                      getSummary={getSummary}
                      isEdit={isEditWidget[`subForms_${subIndex}`]}
                      onChangeIsEdit={(_isEdit) =>
                        handleOnChangeIsEdit(`subForms_${subIndex}`, _isEdit, setIsEditWidget)
                      }
                      onClickExpanded={boolExpanded}
                      projectVersionId={projectVersionId}
                    />
                    // <></>
                  )
                }
              })}
            </Panel>
          )
        } else {
          return (
            <BudgetWidgets
              key={`managementFeeWidget_${index}`}
              formKey={`managementFeeWidget_${index}`}
              shaded={shaded}
              bordered={true}
              showCommandButton={!item.form.disabled}
              // showCommandButton={showCommandButton}
              // isEditAll={isEditAll}
              schema={item.form}
              getSummary={getSummary}
              isEdit={isEditWidget[`managementFeeWidget_${index}`]}
              onChangeIsEdit={(_isEdit) =>
                handleOnChangeIsEdit(`managementFeeWidget_${index}`, _isEdit, setIsEditWidget)
              }
              projectVersionId={projectVersionId}
            />
          )
        }
      })}
    </>
  )
}
